
import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import template from 'advanced-visuals/control-bullet-text.ejs';
import constants        from "Constants";
//=====================================================================
//
// An instance of this view represents a bullet text control.
//
// Alfonso Cabral, February, 2 2016
//
//=====================================================================
class BulletTextControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'textThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }


    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BulletTextControlView';
    }


}

export default BulletTextControlView;

